module.exports = __webpack_public_path__ + "static/media/bomb.9280f166.png";